// extracted by mini-css-extract-plugin
module.exports = {"ResultStep_title":"ResultStep_ResultStep_title__qWFUe","ResultStep_description":"ResultStep_ResultStep_description__xD4CM"};